import { makeStyles } from '@material-ui/styles'
import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { dashboardUrl } from 'app/constants'
import Button from 'core/elements/button'
import Text from 'core/elements/Text'
import type Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(6),
    textAlign: 'center',
    // Focused programmatically on mount; no visible ring needed on the container itself.
    outline: 'none',
  },
}))

const ForbiddenPage = () => {
  const classes = useStyles({})
  const history = useHistory()
  const rootRef = useRef<HTMLDivElement>(null)

  // The denial replaces the page in place (URL unchanged), so move focus here and mark it as
  // an alert so keyboard and screen-reader users are told, rather than left on stale focus.
  useEffect(() => {
    rootRef.current?.focus()
  }, [])

  return (
    <div ref={rootRef} role="alert" tabIndex={-1} className={classes.root}>
      <Text variant="h4">Access Denied</Text>
      <Text variant="body1">You don&apos;t have permission to view this page.</Text>
      <Button onClick={() => history.push(dashboardUrl)}>Return to Dashboard</Button>
    </div>
  )
}

export default ForbiddenPage
